(() => {
  'use strict';
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ps-search]').forEach(root => {
      if (root.dataset.psReady) return;
      root.dataset.psReady = 'true';
      const input = root.querySelector('[data-ps-search-input]');
      const results = root.querySelector('[data-ps-search-results]');
      const status = root.querySelector('[data-ps-search-status]');
      let strings = {};
      try { strings = JSON.parse(root.dataset.psStrings || '{}'); } catch (_) {}
      if (!input || !results) return;
      let timer, controller, request = 0;
      const close = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); };
      const searchRoot = (window.Shopify?.routes?.root || '/');
      input.addEventListener('input', () => {
        clearTimeout(timer);
        if (controller) controller.abort();
        request++;
        const q = input.value.trim();
        if (q.length < 2) { close(); return; }
        const current = request;
        timer = setTimeout(async () => {
          controller = new AbortController();
          try {
            const url = new URL(`${searchRoot}search/suggest.json`, location.origin);
            url.searchParams.set('q', q);
            url.searchParams.set('resources[type]', 'product');
            url.searchParams.set('resources[limit]', '5');
            url.searchParams.set('resources[options][unavailable_products]', 'last');
            const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Search unavailable');
            const data = await response.json();
            if (current !== request || input.value.trim() !== q) return;
            const products = data.resources?.results?.products || [];
            results.replaceChildren();
            if (products.length) {
              products.forEach(product => {
                const link = document.createElement('a');
                link.className = 'ps-header-search__result';
                link.setAttribute('role', 'option');
                link.setAttribute('aria-selected', 'false');
                link.href = product.url;
                const imageUrl = typeof product.image === 'string' ? product.image : product.featured_image?.url;
                if (imageUrl) {
                  const image = document.createElement('img');
                  image.src = imageUrl;
                  image.alt = '';
                  image.width = 48; image.height = 48;
                  link.append(image);
                }
                const title = document.createElement('span');
                title.textContent = product.title;
                link.append(title);
                results.append(link);
              });
            } else {
              const message = document.createElement('p');
              message.className = 'ps-header-search__none';
              message.textContent = strings.empty || '';
              results.append(message);
            }
            const all = document.createElement('a');
            all.className = 'ps-header-search__all';
            all.setAttribute('role', 'option');
            all.setAttribute('aria-selected', 'false');
            all.href = `${searchRoot}search?type=product&q=${encodeURIComponent(q)}`;
            all.textContent = (strings.all || '').replace('__QUERY__', q);
            results.append(all);
            if (status) status.textContent = products.length === 1 ? (strings.countOne || '') : (strings.countMany || '').replace('__COUNT__', String(products.length));
            results.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          } catch (error) { if (error.name !== 'AbortError') close(); }
        }, 220);
      });
      input.addEventListener('keydown', event => {
        if (event.key === 'Escape') { close(); event.preventDefault(); }
        if (event.key === 'ArrowDown' && !results.hidden) { event.preventDefault(); results.querySelector('a')?.focus(); }
      });
      root.addEventListener('keydown', event => {
        if (event.key === 'Escape') { close(); input.focus(); }
        if (['ArrowDown', 'ArrowUp'].includes(event.key) && results.contains(document.activeElement)) {
          const links = [...results.querySelectorAll('a')];
          const index = links.indexOf(document.activeElement);
          const next = index + (event.key === 'ArrowDown' ? 1 : -1);
          event.preventDefault();
          if (next < 0) input.focus(); else links[Math.min(next, links.length - 1)]?.focus();
        }
      });
      root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) close(); });
      document.addEventListener('click', event => { if (!root.contains(event.target)) close(); });
    });
    scope.querySelectorAll('.ps-header details').forEach(detail => {
      if (detail.dataset.psMenuReady) return;
      detail.dataset.psMenuReady = 'true';
      detail.addEventListener('toggle', () => {
        if (!detail.open || detail.closest('.ps-mobile-menu__panel')) return;
        scope.querySelectorAll('.ps-nav-dropdown').forEach(other => { if (other !== detail) other.open = false; });
      });
      detail.addEventListener('keydown', event => {
        if (event.key === 'Escape') { detail.open = false; detail.querySelector(':scope > summary')?.focus(); event.stopPropagation(); }
      });
      document.addEventListener('click', event => { if (!detail.contains(event.target)) detail.open = false; });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
